export default __webpack_public_path__ + "static/media/bank.4635a4a8.svg";